import { styled, Box, Typography } from '@mui/material';

export const CircleContainer = styled(Box)<{ height?: string; noPermissions?: boolean }>`
  height: ${({ height }) => height || '100%'};
  display: flex;
  width: 100%;
  max-height: 100%;
  min-height: 100%;
  align-items: center;
  gap: 16px;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  cursor: ${({ noPermissions }) => (noPermissions ? 'not-allowed' : 'pointer')};
`;

export const Circle = styled(Box)<{ invert?: boolean; color?: string; noPermissions?: boolean }>`
  display: flex;
  aspect-ratio: 1/1;
  min-height: 50%;
  max-height: 50%;
  flex: 2;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({ color, invert, theme, noPermissions }) =>
    noPermissions
      ? theme.color.borderGrey
      : color
      ? color
      : invert
      ? theme.palette.common.white
      : theme.color.darkerBlue};

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  svg {
    max-width: 50%;
    max-height: 50%;
  }
`;

export const TextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
`;

export const Banner = styled(Typography)`
  font-size: 1.1rem;
  text-align: center;
  font-weight: 700;
  margin-top: 4px;
`;

export const Desc = styled(Typography)`
  font-size: 0.87rem;
  text-align: center;
  word-break: break-word;
`;
